import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectAllInstancesIsLoading = (store: StoreSchema) =>
	store.instances.allInstances.isLoading